module.exports = __webpack_public_path__ + "f973e53567c80955f0e52c2aa949c876.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/tape-2.svg
// module id = 484
// module chunks = 0